exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".font-awesome[data-v-65e53d2b] {\n  height: 14px;\n  width: 14px;\n}\n", ""]);

// exports
